import { post, get } from '@/helpers/http'
import utility from '@/helpers/utility'

const state = {
  appInitialized: false,
  verificationHash: false,
  registrationEmail: false,
  appStatus: 'default',
  authPanelStatus: false,
  authPanelView: false,
  appLoading: true,
  homePopup: true,
  insightPopup: true,
  //initOpen: false,
  providerTagIds: {},
  providers: {},
  navopen: false,
  searchopen: false,
  trendingFilters: {},
  filterAmounts: [],
  isDownloadingImage: false,
  marketReportsAmount: '+25 000', // Used?,
  settings: { // Copy this as defaultSettings and use it instead of search.defaultSettings?
    'user': {},
    'search': {
      'view': 'search'
    },
    'datasets': {
      'page': 1,
      'sort': 'relevance',
      'display': 'grid_sm',
      'access': 'all'
    },
    'pdfs': {
      'page': 1,
      'sort': 'relevance',
      'display': 'list',
      'access': 'all'
    },
    'news': {
      'page': 1,
      'sort': 'relevance',
      'display': 'list',
      'access': 'all',
      'before_id': false,
      'after_id': false
    },
    'dataset': {
      'display': 'bar_ver'
    }
  },
  defaultSettings: { // Copy this smarter... to config! then you can easily copy it?
    'user': {},
    'search': {
      'view': 'search'
    },
    'datasets': {
      'page': 1,
      'sort': 'relevance',
      'display': 'grid_sm',
      'access': 'all'
    },
    'pdfs': {
      'page': 1,
      'sort': 'relevance',
      'display': 'list',
      'access': 'all'
    },
    'news': {
      'page': 1,
      'sort': 'relevance',
      'display': 'list',
      'access': 'all',
      'before_id': false,
      'after_id': false
    },
    'dataset': {
      'display': 'bar_ver'
    }
  }
}

const getters = {
  getAppInitialized (state) { return state.appInitialized },
  getVerificationHash (state) { return state.verificationHash },
  getRegistrationEmail (state) { return state.registrationEmail },
  getAuthPanelStatus (state) { return state.authPanelStatus },
  getAuthPanelView (state) { return state.authPanelView },
  getAppLoading (state) { return state.appLoading },
  getAppStatus (state) { return state.appStatus },
  getProviders (state) { return state.providers },
  getProviderTagIds (state) { return state.providerTagIds },
  getHomePopup (state) { return state.homePopup },
  getInsightPopup (state) { return state.insightPopup },
  //getInitOpen (state) { return state.initOpen },
  getNavopen (state) { return state.navopen },
  getSearchopen (state) { return state.searchopen },
  getTrendingFilters (state) { return state.trendingFilters },
  getFilterAmounts (state) { return state.filterAmounts },
  getIsDownloadingImage (state) { return state.isDownloadingImage },
  getMarketReportsAmount (state) { return state.marketReportsAmount },
  getLicensePackages (state) { return state.licensePackages },
  getSettings (state) { return state.settings },
  getDefaultSettings (state) { return state.defaultSettings }
}

const actions = {
  async initialize ({ state, commit, dispatch, rootState }) {
    let response = await get('client/initialize')

    commit('SET_TRENDING_FILTERS', response.data.data.trending_filters)
    commit('SET_PROVIDER_TAG_IDS', response.data.data.provider_tags)
    commit('SET_FILTER_AMOUNTS', {
      topics: '+12k',
      locations: '+250',
      trade_types: '+600',
      scales: '+700',
      providers: '+200'
    })

    if (response.data.data.user && response.data.data.user !== false) {
      let status = response.data.data.user.attributes.subscription_status

      dispatch('user/setState', response.data.data.user, {root:true})
      dispatch('user/refreshState', response.data.data.user.attributes, {root:true})
      dispatch('user/setSubscriptionStatus', status, {root:true})
      dispatch('user/fetchSettings', false, {root:true})
      dispatch('user/fetchNotifications', false, {root:true})
      utility.sendGoogleAnalyticsEvent('auth_logged', false, false, rootState.user.subscriptionStatus)
    } else {
      dispatch('user/setLoginState', false, {root:true})
    }

    //commit('SET_APP_INITIALIZED', true)
  },

  // TODO: This belongs to user, what is it even used for??
  async setRegistrationInfo ({ commit }, hash) {
    try {
      let response = await post('users/verify', { 'verification_hash': hash })

      if (response.data.data.email && response.data.data.verification_hash) {
        commit('SET_REGISTRATION_EMAIL', response.data.data.email)
        commit('SET_VERIFICATION_HASH', response.data.data.verification_hash)

        return true
      }
    } catch (error) {
      return false
    }
  },

  async fetchProviders ({ commit }) {
    let providers = await get('providers?page[size]=500')
    let exclude = ['TEAL', 'BVR', 'PTR']
    commit('SET_PROVIDERS', providers.data.data.filter(p => exclude.indexOf(p.attributes.tag) === -1))
  },

  async feedback ({ commit }, formData) {
    let response = await post('feedbacks', formData)
    return response.data
  },

  async newsletter ({ commit }, formData) {
    let response = await post('client/newsletter', formData)
    return response.data
  },

  setAppInitialized ({ commit }, status) {
    commit('SET_APP_INITIALIZED', status)
  },

  setVerificationHash ({ commit }, value) {
    commit('SET_VERIFICATION_HASH', value)
  },

  setRegistrationEmail ({ commit }, value) {
    commit('SET_REGISTRATION_EMAIL', value)
  },

  setAppStatus ({ commit }, status) {
    commit('SET_APP_STATUS', status ? status : 'default')
  },

  setIsDownloadingImage ({ commit }, value) {
    commit('SET_IS_DOWNLOADING_IMAGE', value)
  },

  setSettings ({ commit }, settings) {
    let newSettings = { ...state.settings }
    let newItems = Array.isArray(settings) ? settings : [settings]

    newItems.forEach(setting => {
      let parts = setting.name.split('.')
      let mainSetting = parts[0]
      let subSetting = parts[1]

      newSettings[mainSetting][subSetting] = setting.value
    })

    commit('SET_SETTINGS', newSettings)
  }
}

const mutations = {
  setAuthPanelStatus (state, value) {
    state.authPanelStatus = value
  },
  setAuthPanelView (state, value) {
    state.authPanelView = value
  },
  setAppLoading (state, value) {
    state.appLoading = value
  },
  setHomePopup (state, value) {
    state.homePopup = value
  },
  setInsightPopup (state, value) {
    state.insightPopup = value
  },
  /*setInitOpen (state, value) {
    state.initOpen = value
  },*/
  setNavopen (state, value) {
    state.navopen = value
  },
  setSearchopen (state, value) {
    state.searchopen = value
  },
  SET_APP_INITIALIZED (state, value) {
    state.appInitialized = value
  },
  SET_VERIFICATION_HASH (state, value) {
    state.verificationHash = value
  },
  SET_REGISTRATION_EMAIL (state, value) {
    state.registrationEmail = value
  },
  SET_APP_STATUS (state, value) {
    state.appStatus = value
  },
  SET_PROVIDER_TAG_IDS (state, value) {
    state.providerTagIds = value
  },
  SET_PROVIDERS (state, value) {
    state.providers = value
  },
  SET_TRENDING_FILTERS (state, value) {
    state.trendingFilters = value
  },
  SET_FILTER_AMOUNTS (state, value) {
    state.filterAmounts = value
  },
  SET_IS_DOWNLOADING_IMAGE (state, value) {
    state.isDownloadingImage = value
  },
  SET_SETTINGS (state, value) {
    state.settings = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
